import React, { useState, useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { ThanksScreen } from "./ThanksScreen";
import { SorryUser } from "./SorryUser";
import { PendingStart } from "./PendingStart";
const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;

const options = {
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
  day: "numeric",
  month: "long",
  year: "numeric",
};

export const QuestionAnswer = (props) => {
  const [totalSubmitQuestionLength, setTotalSubmitQuestionLength] = useState();
  const [finalSubmit, setFinalSubmit] = useState(false);
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [startDateTime, setStartDateTime] = useState();
  const [endDateTime, setEndDateTime] = useState();
  const [answers, setAnswers] = useState({});
  const [error, setError] = useState("");
  const [errorOTP, setErrorOTP] = useState("");
  const [questionAnswerSet, setQuestionAnswerSet] = useState([]);
  const [step, setStep] = useState(0);
  const [activeQuestion, setActiveQuestion] = useState(0);
  const [matchList, setMatchList] = useState([]);
  const [timeLeft, setTimeLeft] = useState();
  const [searchParams] = useSearchParams();
  const [userMobile, setUserMobile] = useState("");
  const [ottsmsId, setottsmsId] = useState(null);
  const [userNameBaseToggle, setUserNameBaseToggle] = useState("");
  const [manyMatchTabID, setManyMatchTabID] = useState(0);
  const paramsMoble = searchParams.get("key")?.replace(/ /g, "+") || null;
  const [withParamsToggle, setWithParamsToggle] = useState(false);
  const { handleSaveUserData } = props;

  const setTimer = (endDateTime) => {
    const targetDate = new Date(endDateTime);
    setTimeLeft(Math.max(0, Math.floor(targetDate - Date.now()) / 1000));
  };

  const [activeTabs, setActiveTabs] = useState(0);

  const timerSetInterval = () => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  };

  const validateMobileAndCheckCTEligibility = useCallback(async () => {
    let userMobile = "";
    let ottsmsid = 0;
    setPageLoading(true);
    const payload = { MobileNumber: paramsMoble };
    try {
      const response = await fetch(
        `${apiBaseURL}/api/IPLContestWatcho/ValidateMobileAndCheckIPLContestEligibility`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response?.status}`);
      const data = await response?.json();
      if (data.resultStatus === "Success") {
        userMobile = data?.result?.mobileNumber;
        ottsmsid = data?.result?.ottsmsId;
        setWithParamsToggle(true);
        setUserNameBaseToggle(data?.result?.userName);
        handleSaveUserData(userMobile, ottsmsid);
        // console.log(userMobile);
        setUserMobile(userMobile);
        setottsmsId(ottsmsid);
        sessionStorage.setItem(
          "leaderBoardCurrentMobileNumber",
          data?.result?.mobileNumber,
        );
        await getQuizScheduleDetails(data);
      } else if (data?.resultStatus === "Failed") {
        setError(data?.message);
      }
    } catch (error) {
      console.error("Error validating mobile number:", error);
    } finally {
      setPageLoading(false);
      handleIPLGTMTaggingOnLanding(
        "lp_view",
        "LandingPage",
        userMobile,
        ottsmsid,
      );
    }
  }, []);

  const handleIPLGTMTaggingOnLanding = (
    event,
    pageName,
    userMobile,
    ottsmsid,
  ) => {
    window.dataLayer.push({
      event: event,
      page_name: pageName,
      source_url: window.location.href,
      mobile_number: userMobile,
      ott_sms_id: ottsmsid,
      date: new Date(Date.now())?.toLocaleString("en-US", options),
      platform: "Watcho_IPLContest2025",
      user_type: "Watcho",
    });
  };

  const getQuizScheduleDetails = async (firstAPIResponse) => {
    setPageLoading(true);
    try {
      const response = await fetch(
        `${apiBaseURL}/api/IPLContestWatcho/GetIPLContestScheduleDetails`,
        {
          method: "GET",
        },
      );
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response?.status}`);
      const IPLContestScheduleDetailsResponse = await response?.json();
      if (IPLContestScheduleDetailsResponse?.resultStatus === "Success") {
        const res = IPLContestScheduleDetailsResponse?.result;
        setMatchList(res);
        startEndTimerCounter(res, manyMatchTabID);

        if (IPLContestScheduleDetailsResponse?.result.length > 0) {
          const thirdAPIPayload = {
            MobileNumber: firstAPIResponse?.result?.mobileNumber,
            ContestId: firstAPIResponse?.result?.ottsmsId,
            Id: res?.[manyMatchTabID]?.id,
          };
          GetDishKiCTQuestions(thirdAPIPayload);
        }
      }
    } catch (error) {
      console.error("Error fetching quiz schedule details:", error);
    } finally {
      setPageLoading(false);
    }
  };

  const startEndTimerCounter = (matchList, manyMatchTabIDx) => {
    const DetailsResponseData = matchList?.[manyMatchTabIDx];
    const formatDateTime = (dateString) => {
      const date = new Date(dateString);
      return date?.toLocaleString("en-US", options);
    };
    setStartDateTime(formatDateTime(DetailsResponseData?.quizStartTime));
    setEndDateTime(formatDateTime(DetailsResponseData?.quizEndTime));
    setTimer(DetailsResponseData?.quizEndTime);
  };

  const GetDishKiCTQuestions = async (thirdAPIPayload) => {
    setFinalSubmit(false);
    setPageLoading(true);
    setLoading(true);
    try {
      const payload = {
        MobileNumber: thirdAPIPayload?.MobileNumber,
        OTTSMSId: thirdAPIPayload?.ContestId,
        Id: thirdAPIPayload?.Id,
      };
      const response = await fetch(
        `${apiBaseURL}/api/IPLContestWatcho/GetIPLContestQuestions`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response?.status}`);
      const data = await response?.json();
      setTotalSubmitQuestionLength(
        data?.result?.filter((q) => q?.isSubmitted === 1),
      );
      if (data?.resultStatus === "Success" && data?.result) {
        setQuestionAnswerSet(data?.result);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setPageLoading(false);
      setLoading(false);
    }
  };

  const matchTabID = async (manyMatchTabIDx) => {
    setManyMatchTabID(manyMatchTabIDx);
    setUserName("");
    setAnswers({});
    setLoading(true);
    setStep(0);
    setActiveTabs(manyMatchTabIDx);
    setActiveQuestion(manyMatchTabIDx);
    setLoading(false);
    startEndTimerCounter(matchList, manyMatchTabIDx);
    if (matchList.length > 0) {
      const questionReq = {
        MobileNumber: userMobile,
        ContestId: ottsmsId,
        Id: matchList?.[manyMatchTabIDx]?.id,
      };
      GetDishKiCTQuestions(questionReq);
    }
  };

  const onSubmit = async () => {
    if (userNameBaseToggle.length > 1) {
      if (step === 0) {
        if (!answers[step]) {
          setError("Please select an answer before proceeding.");
          return;
        }
      }
    } else {
      if (step === 0) {
        if (!answers[step]) {
          setError("Please select an answer before proceeding.");
          return;
        }
      } else if (step === 1) {
        if (!userName.trim()) {
          setError("Please enter your name.");
          return;
        }
      }
    }

    userName?.length > 0 && setUserNameBaseToggle(userName);
    setError("");
    if (userNameBaseToggle.length > 1) {
      const currentQuestion = questionAnswerSet[0];
      const selectedOption = currentQuestion?.options.find(
        (option) => option?.optionId === answers[0],
      );

      try {
        setPageLoading(true);
        setLoading(true);
        const payload = {
          MobileNumber: userMobile,
          OTTSMSID: ottsmsId,
          Name: userName || userNameBaseToggle,
          ContestId: currentQuestion?.contestId || 0,
          QResponse: [
            {
              QId: currentQuestion?.qId || 0,
              SelectedAnswer: selectedOption ? selectedOption?.optionName : "",
            },
          ],
        };

        const contestName = matchList.filter(
          (x) => x.id === currentQuestion?.contestId,
        )[0].contestDetail;
        handleIPLGTMTaggingOnSubmit(
          "contest_submit",
          userMobile,
          ottsmsId,
          currentQuestion?.contestId || 0,
          contestName,
        );

        const response = await fetch(
          `${apiBaseURL}/api/IPLContestWatcho/SubmitIPLContestResponse`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          },
        );

        const data = await response?.json();
        if (data?.resultStatus === "Success" && data?.result) {
          if (!paramsMoble) {
            sessionStorage.setItem("unKnownUserName", payload.Name);
          }
          setFinalSubmit(true);
        }
      } catch (error) {
        console.error("Error fetching questions:", error);
      } finally {
        setPageLoading(false);
        setLoading(false);
      }
    } else {
      if (step === 1) {
        const currentQuestion = questionAnswerSet[0];
        const selectedOption = currentQuestion?.options.find(
          (option) => option?.optionId === answers[0],
        );

        try {
          setPageLoading(true);
          setLoading(true);
          const payload = {
            MobileNumber: userMobile,
            OTTSMSID: ottsmsId,
            Name: userName || userNameBaseToggle,
            ContestId: currentQuestion?.contestId || 0,
            QResponse: [
              {
                QId: currentQuestion?.qId || 0,
                SelectedAnswer: selectedOption
                  ? selectedOption?.optionName
                  : "",
              },
            ],
          };

          const contestName = matchList.filter(
            (x) => x.id === currentQuestion?.contestId,
          )[0].contestDetail;
          handleIPLGTMTaggingOnSubmit(
            "contest_submit",
            userMobile,
            ottsmsId,
            currentQuestion?.contestId || 0,
            contestName,
          );

          const response = await fetch(
            `${apiBaseURL}/api/IPLContestWatcho/SubmitIPLContestResponse`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload),
            },
          );
          const data = await response?.json();
          if (data?.resultStatus === "Success" && data?.result) {
            if (!paramsMoble) {
              sessionStorage.setItem("unKnownUserName", payload.Name);
            }
            setFinalSubmit(true);
          }
        } catch (error) {
          console.error("Error fetching questions:", error);
        } finally {
          setPageLoading(false);
          setLoading(false);
        }
      } else {
        setStep((prev) => prev + 1);
      }
    }
  };

  const handleIPLGTMTaggingOnSubmit = (
    event,
    userMobile,
    ottsmsid,
    contestId,
    contestName,
  ) => {
    window.dataLayer.push({
      event: event,
      mobile_number: userMobile,
      ott_sms_id: ottsmsid,
      platform: "Watcho_IPLContest2025",
      user_type: "Watcho",
      plan_id: contestId,
      asset_title: contestName,
      date: new Date(Date.now())?.toLocaleString("en-US", options),
    });
  };

  const handleSelect = (optionId) => {
    setAnswers((prev) => ({
      ...prev,
      [step]: optionId,
    }));
  };

  // fmbmmnbfjerjn
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const [checkRewardsPointsStructure, setCheckRewardsPointsStructure] =
    useState(false);

  useEffect(() => {
    let timer;
    if (isOtpSent && countdown > 0) {
      timer = setInterval(() => setCountdown((prev) => prev - 1), 1000);
    }
    return () => clearInterval(timer);
  }, [isOtpSent, countdown]);

  const sendOtp = async () => {
    setErrorOTP("");
    setOtp(["", "", "", ""]);
    if (!/^[6-9]\d{9}$/.test(mobile)) {
      setErrorOTP("Please enter a valid 10-digit mobile number.");
      return;
    }
    setLoading(true);
    try {
      setIsOtpSent(true);

      const payload = { MobileNumber: mobile };
      const response = await fetch(
        `${apiBaseURL}/api/IPLContestWatcho/GenerateOTPForIPLContest`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();
      if (response.ok && data.resultStatus === "Success") {
        setIsOtpSent(true);
        setCountdown(60);
        // setError(data.resultMessage || "Failed to send OTP.");
      } else {
        setErrorOTP(data.resultMessage || "Failed to send OTP.");
      }
    } catch (err) {
      // setError("Uh oh! The OTP you have entered is invalid");
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {
    setErrorOTP("");
    if (otp.some((digit) => digit === "")) {
      setErrorOTP("Please enter the complete OTP.");
      return;
    }
    let userMobile = "";
    let ottsmsid = 0;
    setFinalSubmit(false);
    setPageLoading(true);
    const payload = {
      MobileNo: mobile,
      OTP: otp.join(""),
    };
    try {
      const response = await fetch(
        `${apiBaseURL}/api/IPLContestWatcho/ValidateOTPForIPLContest`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response?.status}`);
      const data = await response?.json();
      if (data.resultStatus === "Success") {
        setWithParamsToggle(true);
        setUserNameBaseToggle(data?.result?.userName);
        setCheckRewardsPointsStructure(false);
        userMobile = data?.result?.mobileNumber;
        ottsmsid = data?.result?.ottsmsId;
        handleSaveUserData(userMobile, ottsmsid);
        setUserMobile(data?.result?.mobileNumber);
        const base64Mobile = btoa(String(userMobile || ""));
        sessionStorage.setItem("unKnownUsermobile", base64Mobile);
        sessionStorage.setItem("unKnownottsmsid", ottsmsid);
        sessionStorage.setItem("unKnownUserName", data?.result?.userName);

        sessionStorage.setItem(
          "leaderBoardCurrentMobileNumber",
          data?.result?.mobileNumber,
        );
        // console.log(data?.result?.mobileNumber);
        setottsmsId(data?.result?.ottsmsId);
        await getQuizScheduleDetails(data, 0);
      } else if (data?.resultStatus === "Failed") {
        setErrorOTP(data?.resultMessage);
      }
    } catch (error) {
      console.error("Error validating mobile number:", error);
    } finally {
      setPageLoading(false);
      handleIPLGTMTaggingOnLanding(
        "lp_view",
        "LandingPage",
        userMobile,
        ottsmsid,
      );
    }
  };

  //const handleOtpChange = (index, value) => {
  //  if (!/^[0-9]?$/.test(value)) return;
  //  let newOtp = [...otp];
  //  newOtp[index] = value;
  //  setOtp(newOtp);
  //  if (value && index < 3) document.getElementById(`otp-${index + 1}`).focus();
  //};

  const handleOtpChange = (index, value) => {
    if (!/^[0-9]?$/.test(value)) return;
    let newOtp = [...otp];
    newOtp[index] = value;
    // Move to the next input if a number is entered
    if (value && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
    // Move to the previous input if deleting
    if (!value && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }

    setOtp(newOtp);
  };

  useEffect(() => {
    sessionStorage.removeItem("leaderBoardCurrentMobileNumber");
    sessionStorage.removeItem("backURLs");
    sessionStorage.setItem("backURLs", paramsMoble || "IPLContestWatcho"); //unKnownUsermobile
    const getunKnownUsermobileBase64 =
      sessionStorage.getItem("unKnownUsermobile");
    const getunKnownUsermobile = getunKnownUsermobileBase64
      ? atob(getunKnownUsermobileBase64)
      : "";
    if (paramsMoble) {
      sessionStorage.removeItem("unKnownUsermobile");
      sessionStorage.removeItem("unKnownottsmsid");
      sessionStorage.removeItem("unKnownUserName");
      validateMobileAndCheckCTEligibility(activeTabs);
    } else {
      if (getunKnownUsermobile && getunKnownUsermobile.length === 10) {
        setFinalSubmit(false);
        const unKnownottsmsid = sessionStorage.getItem("unKnownottsmsid");
        const unKnownUserName = sessionStorage.getItem("unKnownUserName");
        setWithParamsToggle(true);
        setUserNameBaseToggle(unKnownUserName);
        setCheckRewardsPointsStructure(false);
        handleSaveUserData(getunKnownUsermobile, parseInt(unKnownottsmsid));
        setUserMobile(getunKnownUsermobile);
        setottsmsId(parseInt(unKnownottsmsid));
        const data = {
          result: {
            mobileNumber: getunKnownUsermobile,
            ottsmsId: parseInt(unKnownottsmsid),
          },
        };
        getQuizScheduleDetails(data, 0);
      } else {
        setCheckRewardsPointsStructure(true);
        sessionStorage.removeItem("unKnownUsermobile");
        sessionStorage.removeItem("unKnownottsmsid");
        sessionStorage.removeItem("unKnownUserName");
      }
    }

    timerSetInterval();
  }, [validateMobileAndCheckCTEligibility]);

  return (
    <>
      <div
        className={`modal mobile-verify-modal ${
          checkRewardsPointsStructure ? "show" : "fade"
        }`}
        id="exampleModal1"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div style={{ width: "100%" }}>
              <div className="modal-header-custom">
                <button
                  type="button"
                  className="close-custom"
                  onClick={() => {
                    setCheckRewardsPointsStructure(false);
                    setIsOtpSent(false);
                    setErrorOTP("");
                    setMobile("");
                    setOtp(["", "", "", ""]);
                  }}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                {!isOtpSent ? (
                  <>
                    <h6>Register & Participate Now!</h6>
                    <p>
                      Enter your Mobile Number, verify OTP, and get ready to win
                      big!
                    </p>
                    <div className="input-group">
                      <span className="input-group-addon">
                        <img
                          src="../images/iplContest/flag-india.png"
                          alt="India Flag"
                          style={{ maxWidth: "24px" }}
                        />{" "}
                        +91
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter mobile number"
                        maxLength={10}
                        value={mobile}
                        onChange={(e) =>
                          setMobile(e.target.value.replace(/[^0-9]/g, ""))
                        }
                      />
                    </div>
                    {errorOTP && <p className="text-danger">{errorOTP}</p>}
                    <button
                      className="btn btn-danger btn-block"
                      onClick={sendOtp}
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Get OTP"}
                    </button>
                  </>
                ) : (
                  <>
                    <h6>OTP Verification</h6>
                    <p>
                      Enter the 4-digit code <br />
                      sent to: +91 {mobile}{" "}
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setIsOtpSent(false);
                          setErrorOTP("");
                        }}
                      >
                        <img
                          src="../images/iplContest/ant_edit.png"
                          alt="Edit"
                          style={{ maxWidth: "24px" }}
                        />
                      </span>
                    </p>
                    <div className="otp-inputs">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          id={`otp-${index}`}
                          type="text"
                          maxLength={1}
                          className="otp-box"
                          value={digit}
                          onChange={(e) =>
                            handleOtpChange(index, e.target.value)
                          }
                        />
                      ))}
                    </div>
                    {errorOTP && <p className="text-danger">{errorOTP}</p>}

                    {countdown > 0 && (
                      <p className="mt-2">
                        Resend OTP in <strong>0:{countdown}</strong>
                      </p>
                    )}

                    {countdown === 0 && (
                      <span
                        className="resendOTP"
                        onClick={sendOtp}
                        disabled={loading}
                      >
                        Resend OTP
                      </span>
                    )}

                    <button
                      className="btn btn-danger btn-block"
                      onClick={verifyOtp}
                      disabled={loading}
                    >
                      {loading ? "Verifying..." : "Confirm OTP"}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="quiz-container" style={{ maxWidth: "100%" }}>
        {pageLoading ? (
          <span className="DishKiChampionsTrophy-loader"></span>
        ) : (
          <>
            {loading ? (
              <span className="DishKiChampionsTrophy-loader"></span>
            ) : (
              <>
                {/* {userNameBaseToggle} */}

                {withParamsToggle ? (
                  <>
                    {matchList?.length === 0 ? (
                      <>
                        <PendingStart />
                      </>
                    ) : (
                      <>
                        {matchList?.length > 1 ? (
                          <div className="number-of-match">
                            {matchList.map((item, index) => (
                              <span
                                key={item?.id || index}
                                onClick={() => matchTabID(index)}
                                className={`match-name ${index} ${
                                  activeQuestion === index ? "active" : ""
                                }`}
                              >
                                {item?.contestDetail ||
                                  "No Contest Details"}{" "}
                              </span>
                            ))}
                          </div>
                        ) : (
                          ""
                        )}
                        {questionAnswerSet[step]?.isSubmitted === 1 ? (
                          <SorryUser
                            isSubmitted={questionAnswerSet[step]?.isSubmitted}
                            isContestEnded={
                              questionAnswerSet[step]?.isContestEnded
                            }
                            IsCorrectAns={questionAnswerSet[step]?.isCorrectAns}
                            endDateTime={endDateTime}
                          />
                        ) : (
                          <>
                            {finalSubmit ? (
                              <>
                                <ThanksScreen endDateTime={endDateTime} />
                              </>
                            ) : (
                              <>
                                {questionAnswerSet[step]?.isContestEnded ===
                                1 ? (
                                  <SorryUser
                                    isSubmitted={
                                      questionAnswerSet[step]?.isSubmitted
                                    }
                                    isContestEnded={
                                      questionAnswerSet[step]?.isContestEnded
                                    }
                                    IsCorrectAns={
                                      questionAnswerSet[step]?.isCorrectAns
                                    }
                                    endDateTime={endDateTime}
                                  />
                                ) : (
                                  <>
                                    {userNameBaseToggle.length > 1 ? (
                                      ""
                                    ) : (
                                      <div className="progress-bar-box">
                                        <div
                                          className={`progress-step ${
                                            step >= 0 ? "active" : ""
                                          } ${step > 0 ? "green" : ""}`}
                                        >
                                          {step > 0 ? "✔" : ""}
                                        </div>
                                        <div
                                          className={`progress-line ${
                                            step > 0 ? "completed" : ""
                                          }`}
                                        ></div>
                                        <div
                                          className={`progress-step ${
                                            step >= 1 ? "active" : ""
                                          }`}
                                        >
                                          {step > 1 ? "✔" : ""}
                                        </div>
                                      </div>
                                    )}

                                    <div className="question-content">
                                      {step === 0 && (
                                        <>
                                          <div className="question-title">
                                            {
                                              questionAnswerSet[step]
                                                ?.questionText
                                            }
                                          </div>

                                          <div className="options-grid">
                                            {questionAnswerSet[
                                              step
                                            ]?.options?.map((option) => (
                                              <label
                                                key={option?.optionId}
                                                className="option-card"
                                              >
                                                <input
                                                  type="radio"
                                                  name={`question-${step}`}
                                                  value={option?.optionId}
                                                  checked={
                                                    answers[step] ===
                                                    option?.optionId
                                                  }
                                                  onChange={() =>
                                                    handleSelect(
                                                      option?.optionId,
                                                    )
                                                  }
                                                />
                                                <span className="custom-radio"></span>
                                                {option?.optionName}
                                              </label>
                                            ))}
                                          </div>
                                        </>
                                      )}

                                      {userNameBaseToggle.length > 1 ? (
                                        ""
                                      ) : (
                                        <>
                                          {step === 1 && (
                                            <div className="user-name">
                                              <label>
                                                Please Enter Your Name
                                              </label>
                                              <input
                                                type="text"
                                                value={userName}
                                                onChange={(e) => {
                                                  const value =
                                                    e.target.value.replace(
                                                      /[^a-zA-Z0-9 ]/g,
                                                      "",
                                                    );
                                                  if (value?.length <= 25) {
                                                    setUserName(value);
                                                  }
                                                }}
                                                placeholder="Enter Name"
                                              />
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                    {error && (
                                      <p
                                        className="error-message"
                                        style={{ color: "#f1d500" }}
                                      >
                                        {error}
                                      </p>
                                    )}

                                    {userNameBaseToggle.length > 1 ? (
                                      <button
                                        className="submit-btn"
                                        onClick={onSubmit}
                                      >
                                        {userNameBaseToggle.length > 1
                                          ? "Submit"
                                          : ""}{" "}
                                        <i className="fa-solid fa-arrow-right"></i>
                                      </button>
                                    ) : (
                                      <button
                                        className="submit-btn"
                                        onClick={onSubmit}
                                      >
                                        {step < 1 ? "Next" : "Submit"}{" "}
                                        <i className="fa-solid fa-arrow-right"></i>
                                      </button>
                                    )}

                                    <div className="timer-box">
                                      <h4>
                                        Prediction Line opens at {startDateTime}{" "}
                                        and closes at {endDateTime}.
                                      </h4>
                                      <br />
                                      <h3>Hurry Contest Ends in</h3>

                                      <div className="timer">
                                        <div className="timesCounter">
                                          <span>
                                            {String(
                                              Math.floor(timeLeft / 3600),
                                            ).padStart(2, "0")}
                                          </span>
                                          <p>HRS</p>
                                        </div>
                                        <span className="timesCounterSepration">
                                          :
                                        </span>
                                        <div className="timesCounter">
                                          <span>
                                            {String(
                                              Math.floor(
                                                (timeLeft % 3600) / 60,
                                              ),
                                            ).padStart(2, "0")}
                                          </span>
                                          <p>Mins</p>
                                        </div>
                                        <span className="timesCounterSepration">
                                          :
                                        </span>
                                        <div className="timesCounter">
                                          <span>
                                            {String(
                                              Math.floor(timeLeft % 60),
                                            ).padStart(2, "0")}
                                          </span>
                                          <p>Secs</p>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <div className="winner-container centerElement">
                      <div className="winner-header">
                        <div className="winner-icon">
                          <img
                            src="/Images/happy-face.png"
                            alt="Winner Prize"
                          />
                        </div>
                        <h2 className="question-title">
                          Register & Participate Now!
                        </h2>
                        <p>
                          Enter your Mobile Number, verify OTP, and get ready to
                          win big!
                        </p>
                        <span
                          className="open-modal-register"
                          onClick={() => setCheckRewardsPointsStructure(true)}
                        >
                          Register & Participate Now!
                        </span>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};
